export default {
	es: {

		enlaces : {
			alumnos : "/alumnos-y-alumni",
			empresas : "/empresas",
			observatorio : "/observatorio-de-empleo",
			orientacion : "/orientacion",
			equipo : "/equipo",
			eventos : "/eventos",
			buscadorrecursos : "/orientacion/buscador-de-recursos",
			internacional : "/internacional",
			guia : "/internacional/guia",
			buscadorrecursosinternacional : "/internacional/buscador-de-recursos",
			aldia : "/al-dia",
			conectados : "/conectados",
			contacto : "/contacto",
			recursos : "/recursos",

		},
		meses : [
			"Enero",
			"Febrero",
			"Marzo",
			"Abril",
			"Mayo",
			"Junio",
			"Julio",
			"Agosto",
			"Septiembre",
			"Octubre",
			"Noviembre",
			"Diciembre"
		],
		formulario : {
			nombre : "Nombre",
			nombre_apellidos : "Nombre y apellidos",
			apellidos : "Apellidos",
			email : "Email de contacto",
			mensaje : "Consulta",
			descripcion : "Breve descripción de trayectoria, formación, áreas de conocimiento o ámbitos en los que crees que puedes ser de ayuda para quienes comienzan.",
			fecha_nacimiento : "Fecha de nacimiento",
			dia : "Día",
			mes : "Mes",
			anyo : "Año",
			area_interes : "Área de su interés",
			trabaja_actualmente : "¿Trabaja actualmente?",
			si : "Si",
			no : "No",
			carta_presentacion : "Carta de presentacion",
			meses : {
				Enero : "Enero",
				Febrero : "Febrero",
				Marzo : "Marzo",
				Abril : "Abril",
				Mayo : "Mayo",
				Junio : "Junio",
				Julio : "Julio",
				Agosto : "Agosto",
				Septiembre : "Septiembre",
				Octubre : "Octubre",
				Noviembre : "Noviembre",
				Diciembre : "Diciembre"
			},
			archivo_adjunto : "Adjuntar archivo",
			adjuntar_cv : "Adjuntar CV",
			introduce_mail : "Introduce tu email",
			pais : "País",
			asunto : "Asunto",
			telefono : "Teléfono de contacto",
			he_leido : "He leído y acepto la",
			y_acepto : "política de privacidad",
			enviar : "Enviar",
			enviado : "Enviado",
		},

	},
	en: {
		enlaces : {
			actualidad : '/news',
			sala_de_prensa : "/press-room",
			contacto : "/contact",
			trabaja_con_nosotros: "/work-with-us",
			politica_privacidad : "/privacy-policy",
			politica_cookies : "/cookies-policy",
		}
	}
}



// WEBPACK FOOTER //
// ./src/translations/index.js